import { render, staticRenderFns } from "./DetailShipmentPlan.vue?vue&type=template&id=589f2534&scoped=true"
import script from "./DetailShipmentPlan.vue?vue&type=script&lang=js"
export * from "./DetailShipmentPlan.vue?vue&type=script&lang=js"
import style0 from "./DetailShipmentPlan.vue?vue&type=style&index=0&id=589f2534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f2534",
  null
  
)

export default component.exports